import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ReactComponent as BusinessIcon } from '../../../assets/icons/business.svg';
import { ReactComponent as GovernmentIcon } from '../../../assets/icons/government.svg';
import { ReactComponent as CheckIcon } from '../../../assets/icons/check-icon.svg';
import classes from './index.module.scss';

const RegistrationTypes = () => {
  return (
    <section className={classes.Basic_Info} id="basic-info">
      <Container>
        <Row>
          <Col lg={{ span: 5, offset: 1 }} md={6}>
            <div className={`${classes.Basic_Info_Column} ${classes.Basic_Info_Column_Business}`}>
              <BusinessIcon 
                className={classes.Basic_Info_Column_Icon}
              />
              <h2 className={classes.Basic_Info_Column_Title}>
                Business
              </h2>
              <ul className={classes.Basic_Info_Column_List}>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  <b>Register for Free</b>
                </li>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  Match to federal opportunities
                </li>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  Post your B2B opportunities
                </li>
              </ul>
              <Link
                to="/registration-preview"
                className="btnSizes filledBtn w-100 py-3"
              >
                Register
              </Link>
            </div>
          </Col>
          <Col lg={5} md={6}>
            <div className={`${classes.Basic_Info_Column} ${classes.Basic_Info_Column_Government}`}>
              <GovernmentIcon 
                className={classes.Basic_Info_Column_Icon}
              />
              <h2 className={classes.Basic_Info_Column_Title}>
                Government
              </h2>
              <ul className={classes.Basic_Info_Column_List}>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  <b>Register for Free</b>
                </li>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  Do market research
                </li>
                <li className={classes.Basic_Info_Column_List_Item}>
                  <CheckIcon 
                    className={classes.Basic_Info_Column_Check_Icon}
                  />
                  Post contract opportunities
                </li>
              </ul>
              <Link
                to="/registration?role=officer"
                className="btnSizes filledBtn w-100 py-3"
              >
                Register
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default RegistrationTypes;